import { createSlice } from '@reduxjs/toolkit'

export const sales = createSlice({
	name: 'sales',
	initialState: {
		client: '',
		imei: '',
		cardCode: '',
		page: 0,
		startDate: '',
		endDate: '',
	},
	reducers: {
		setClient: (state, action) => {
			state.client = action.payload
		},
		setImei: (state, action) => {
			state.imei = action.payload
		},
		setCardCode: (state, action) => {
			state.cardCode = action.payload
		},
		setPage: (state, action) => {
			state.page = action.payload
		},
		setStartDate: (state, action) => {
			state.startDate = action.payload
		},
		setEndDate: (state, action) => {
			state.endDate = action.payload
		},
	},
})
